"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CustomMustacheFunctionsBuilder {
    constructor(customFunctions) {
        this._customFunctions = customFunctions;
    }
    static getInstance(customFunctions) {
        if (!CustomMustacheFunctionsBuilder.instance) {
            CustomMustacheFunctionsBuilder.instance =
                new CustomMustacheFunctionsBuilder(customFunctions);
        }
        return CustomMustacheFunctionsBuilder.instance;
    }
    static create(customFunctions) {
        if (CustomMustacheFunctionsBuilder.instance) {
            throw new Error('CustomMustacheFunctionsBuilder already initialized. Use CustomMustacheFunctionsBuilder.getInstance() instead');
        }
        CustomMustacheFunctionsBuilder.instance =
            new CustomMustacheFunctionsBuilder(customFunctions);
        return CustomMustacheFunctionsBuilder.instance;
    }
    get customFunctions() {
        return this._customFunctions;
    }
}
exports.default = CustomMustacheFunctionsBuilder;
//# sourceMappingURL=CustomMustacheFunctionsBuilder.js.map